import { Component, OnInit } from '@angular/core';
import {
  MapLink,
  PendingMapLink,
  ProgramMap,
  PublishedProgramSummary
} from "../../../../../shared/programmapper-authoring.model";
import {ActivatedRoute, Router} from "@angular/router";
import {LinkedMapsService} from "../linked-maps.service";
import {MessageService} from "../../../../../shared/message/message.service";

@Component({
  selector: 'app-linked-maps-unlink-pending-confirm-modal',
  templateUrl: './linked-maps-unlink-pending-confirm-modal.component.html',
})
export class LinkedMapsUnlinkPendingConfirmModalComponent implements OnInit {

  program: PublishedProgramSummary;
  sourceMap: ProgramMap;
  pendingMapToUnlink: PendingMapLink;
  saving = false;

  constructor(
    protected router: Router,
    private route: ActivatedRoute,
    private linkedMapsService: LinkedMapsService,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.program = this.linkedMapsService.program;
    this.sourceMap = this.linkedMapsService.sourceMap;
    this.pendingMapToUnlink = this.linkedMapsService.pendingMapToUnlink;
  }

  cancel() {
    this.closeModal();
  }

  closeModal() {
    this.router.navigate([{ outlets: { popup: null } }], {relativeTo: this.route.parent, skipLocationChange: true}).then(
      () => {
        this.router.navigate([{ outlets: { subPopup: ['linked-maps'] } }],
          { relativeTo: this.route.parent, skipLocationChange: true });
      }
    );
  }

  unlinkPending() {
    this.saving = true;
    // delete the mapToUnlink.
    // TODO: error handle response here
    this.linkedMapsService.deletePendingMapLink(this.linkedMapsService.sourceMap.id, this.pendingMapToUnlink.linkedProgramId).subscribe(
      (response: boolean) => {
//        this.messageService.add(`Link successfully removed.`, 'icon-notify');
        this.closeModal();
      },
    );
  }

}
